import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, type BoxProps } from '@mui/joy';

import { selectors } from '../../store';

import { AnthropicIcon, OpenAiIcon, XaiIcon } from './assets';

interface ModelIconProps extends BoxProps {
  modelId: number;
  size?: number; // px
}

const ModelIcon = (props: ModelIconProps) => {
  const { modelId, size = 32, sx, ...restProps } = props;

  const availableModels = useSelector(selectors.availableModels);

  const availableModelsIconMap = useMemo(() => {
    const result: Record<number, string> = {};
    availableModels.forEach(({ id, model }) => {
      if (/^gpt/i.test(model)) {
        result[id] = 'openai';
        return;
      }
      if (/^o[0-9]/i.test(model)) {
        result[id] = 'openai';
        return;
      }
      if (/^claude/i.test(model)) {
        result[id] = 'anthropic';
        return;
      }
      if (/^grok/i.test(model)) {
        result[id] = 'xai';
        return;
      }
      result[id] = 'other';
    });
    return result;
  }, [availableModels]);

  const IconComp = useMemo(() => {
    if (availableModelsIconMap[modelId] === 'xai') {
      return XaiIcon;
    }
    if (availableModelsIconMap[modelId] === 'openai') {
      return OpenAiIcon;
    }
    if (availableModelsIconMap[modelId] === 'anthropic') {
      return AnthropicIcon;
    }
    return OpenAiIcon;
  }, [availableModelsIconMap, modelId]);

  return (
    <Box
      {...restProps}
      sx={{
        display: 'inline-flex',
        width: size,
        height: size,
        // 'svg': { fill: 'currentColor' },
        ...sx,
      }}
    >
      <IconComp width="100%" height="100%" />
    </Box>
  );
};

export default memo(ModelIcon);
